'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridOptions = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getGridOptions = exports.getGridOptions = function getGridOptions(type, options) {
  var grid = { baselines: [0], color: 'white' };
  var hideGrid = R.assoc('thickness', 0);

  return R.pipe(R.propOr({}, 'grid'), R.mergeDeepRight({ x: grid, y: grid }), R.cond([[R.always(R.equals(_constants.BAR, type)), R.mergeDeepRight({ x: { thickness: 0 } })], [R.always(R.equals(_constants.ROW, type)), R.mergeDeepRight({ y: { thickness: 0 } })], [R.always(R.equals(_constants.TIMELINE, type)), R.mergeDeepRight({ x: { thickness: 0 } })], [R.always(R.equals(_constants.H_SYMBOL, type)), R.mergeDeepRight({ y: { thickness: 0 } })], [R.always(R.equals(_constants.V_SYMBOL, type)), R.mergeDeepRight({ x: { thickness: 0 } })], [R.always(R.equals(_constants.STACKED_BAR, type)), R.mergeDeepRight({ x: { thickness: 0 } })], [R.always(R.equals(_constants.STACKED_ROW, type)), R.mergeDeepRight({ y: { thickness: 0 } })], [R.T, R.identity]]))(options);
};